module.exports = __webpack_public_path__ + "img/frontpage-main.04018462.png";